import { firebaseErrors } from "@quickpoint.me/shared";

type FirebaseErrorLike = {
    code?: string;
    cause?: string;
};

const isFirebaseErrorLike = (e: unknown): e is FirebaseErrorLike =>
    typeof e === "object" && e !== null && ("code" in e || "cause" in e);

const parseFirebaseErrors = (error: unknown): false | string => {
    let errorRes: false | string = false;

    // @ts-ignore
    if (import.meta.env.TEST) {
        if (isFirebaseErrorLike(error) && typeof error.cause === "string") {
            // @ts-ignore
            errorRes = firebaseErrors[error.cause];
        }
        return errorRes;
    }

    if (isFirebaseErrorLike(error) && typeof error.code === "string") {
        // @ts-ignore
        errorRes = firebaseErrors[error.code];
    }

    return errorRes;
};

export default parseFirebaseErrors;
